import { FC, ReactNode } from 'react';
import { cn } from '@crisellevaldez/speculo-ui';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

export const PageContainer: FC<PageContainerProps> = ({ children, className }) => {
  return (
    <div className={cn('w-full max-w-[1400px] 3xl:max-w-[1800px] mx-auto px-4 md:px-6 lg:px-8', className)}>
      {children}
    </div>
  );
};
